import React from 'react'
import styled from 'styled-components'

import { Skeleton } from '@blade/ui-kit'

export const CurrencyListItemSkeleton: React.FC = () => {
  return (
    <CurrencyListItemRoot>
      <Skeleton variant="circular" height={24} width={24} />
      <Middle>
        <Skeleton height={14} width={50} />
        <Skeleton height={14} width={80} />
      </Middle>
    </CurrencyListItemRoot>
  )
}

const CurrencyListItemRoot = styled.div`
  cursor: pointer;
  display: grid;
  padding-inline: 12px;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  height: 56px;
  border-bottom: 1px solid rgba(255 255 255 / 5%);

  &:last-child {
    border-bottom: none;
  }
`

const Middle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-left: 20px;
  gap: 4px;
`
